import React from 'react';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { MBTextBody1 } from '@shared/components/typography';
import { DateField } from '@shared/data/entity/fields/DateField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: DateField;
  style: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

export function DateCollectionViewField({ field, style, textStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={style}>
      <MBTextBody1 style={textStyle} numberOfLines={1}>
        {field.formattedDate}
      </MBTextBody1>
    </CardCollectionViewFieldContainer>
  );
}
